import React, { type FunctionComponent } from 'react'
import { type FormikProps } from 'formik'
import { trackEvent } from 'utils/events/trackEvent'
import {
  type ProductFormValues,
  type NewProductFormValues,
  type PrimaryImageAngle,
} from 'legacy/routes/catalog/types/product.types'
import FormSection from './FormSection'
import ProductImageUploader from './ProductImageUploader/ProductImageUploader'
import ProductTypeInfoModal from './ProductTypeInfoModal'

export const PRIMARY_IMAGE_FIELD_NAME: PrimaryImageAngle = 'primaryImageUrl'

type Props = {
  required?: boolean
  disabled?: boolean
} & (FormikProps<ProductFormValues> | FormikProps<NewProductFormValues>)

export const ProductImage: FunctionComponent<Props> = ({
  values,
  required,
  disabled,
  errors,
  setFieldValue,
}) => {
  const error = errors[PRIMARY_IMAGE_FIELD_NAME]

  const handleChange = (url: string): void => {
    trackEvent({
      id: 'catalog.products.add_product.uploaded_primary_image',
      description: 'Uploaded a primary image',
    })

    setFieldValue(PRIMARY_IMAGE_FIELD_NAME, url, true)
  }

  return (
    <FormSection
      titleId="catalog.product.image"
      renderAction={() => (disabled ? <ProductTypeInfoModal /> : null)}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <ProductImageUploader
          required={required}
          disabled={disabled}
          imageUrl={values[PRIMARY_IMAGE_FIELD_NAME]}
          onChange={handleChange}
          error={error}
        />
      </div>
    </FormSection>
  )
}
